import React, { useState, useEffect, useContext } from "react";

import lbl from "../../data/Labels.json";

import Img from "../common/Img";

import db from "../../services/query";
import FabButtons from "./FinanceFabButtons";

import { PopUpContext } from "../../contexts/popUpContext";
import { HalfYearContext } from "../../contexts/halfYearContext";

import PastBalanceBtn from "./PastBalanceBtn";
import PaymentsList from "./FinancePaymentsList";
import PayablesList from "./FinancePayablesList";
import ReportItemList from "./ReportItemList";
import ReportItemHeader from "../common/ReportItemHeader";
import FinanceSummaryCard from "./FinanceSummaryCard";

const FinanceProfile = (props) => {
  const { cid } = props.match.params;

  const { popUp } = useContext(PopUpContext);
  const { halfYear } = useContext(HalfYearContext);

  const [data, updateData] = useState([]);
  const [activeYear, setYear] = useState(halfYear);

  useEffect(async () => {
    const ac = new AbortController();

    requestData();

    return () => ac.abort();
  }, [popUp]);

  const requestData = async () => {
    let query = `contractors/${cid}/payments`;

    await db.getAll(query).then(({ data }) => {
      updateData(data);
    });
  };

  return (
    <React.Fragment>
      <div className="finance-profile-area">
        <div className="std-profile">
          <div className="wrapper">
            <Img src={data?.summary?.photo} border={true} />
          </div>
        </div>
        <div className="overall-summary">
          <div className="wrapper">
            <p>{lbl.OverallBalance}</p>
            <h1>{data?.summary?.overall_balance}</h1>
          </div>
        </div>
        <div className="controls">
          <FabButtons cache={cid} />
        </div>
      </div>
      <div className="finance-report-area">
        <div className="report-container _75-per">
          <ReportItemHeader title={lbl.Details} />

          <div className="report-table-area">
            <PayablesList activeYear={activeYear} data={data && data} />
            <PaymentsList activeYear={activeYear} data={data && data} />
          </div>
          <div className="report-summary-area">
            <FinanceSummaryCard
              title={lbl.Summary}
              data={data}
              activeYear={activeYear}
            />
          </div>
        </div>

        <div className="report-container _25-per">
          <ReportItemHeader title={lbl.Semester} />
          <ReportItemList
            data={data}
            setYear={setYear}
            activeYear={activeYear}
          />
          <PastBalanceBtn data={data} cache={cid} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default FinanceProfile;
